import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
 
export class SuccessComponent implements OnInit {
  Loader=false;
  constructor(private route: ActivatedRoute, private payementService:PaymentService,
    private toastr: ToastrService,
    private router: Router
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const paymentIntentId = params['payment_intent'];
      if (paymentIntentId) {
        this.Loader=true;
        // this.payementService.logPayment(paymentIntentId);
        this.SaveTransaction(paymentIntentId);
      }
    });
  }

  async SaveTransaction(paymentIntentId:string){
    await this.payementService.logPayment(paymentIntentId).subscribe
      ({
        next: (res: any) => {
          console.log(res);
         this.Loader=false;
         this.toastr.success('Transaction Processed Successfully');
         this.router.navigateByUrl('/payments');

        },
        error: e => {
          if (e.error.message) {
            this.Loader = false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.Loader = false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
  
}